
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

export default function NineAnglesSection() {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  return (
    <section ref={sectionRef} className="py-32 px-6 bg-[#F8F7F5]">
      <div className="max-w-6xl mx-auto">
        {/* ヘッダー */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="text-center mb-12"
        >
          <p className="text-xs tracking-[0.3em] text-[#8B6BAE] uppercase mb-4">
            9 Angles for Illustrators
          </p>
          <h2
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-6 leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            イラストレーターの為の<span className="text-[#8B6BAE]">9</span>つの角度
          </h2>
          <p className="text-base md:text-lg text-[#6B6B6B] max-w-2xl mx-auto leading-relaxed">
            描く、見る、調べる、観る。<br className="hidden md:block" />
            すべての創作行為に、最適な角度がある。
          </p>
        </motion.div>

        {/* メイン画像 */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, delay: 0.2, ease: 'easeOut' }}
          className="relative"
        >
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/edited_625514bb1fedcf20a7f68ac6b0468f52_56082099.jpg"
              alt="Atelier Folio 9つの角度バリエーション"
              className="w-full h-auto object-cover"
            />
            {/* オーバーレイグラデーション */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent pointer-events-none" />
          </div>
        </motion.div>

        {/* 下部テキスト */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.8, ease: 'easeOut' }}
          className="text-center mt-20"
        >
          <p className="text-sm text-[#9B9B9B] mb-2">次のセクションで詳しく解説</p>
          <div className="inline-flex items-center gap-2 text-[#8B6BAE]">
            <span className="text-base font-medium">なぜ角度が重要なのか</span>
            <i className="ri-arrow-down-line text-lg animate-bounce" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
